module.exports = __webpack_public_path__ + "static/media/007.0c299b2e.jpg";